import { Component, OnInit } from '@angular/core';
import { SimpleTravel } from './product.types';
import { ActivatedRoute, Params, NavigationEnd, Router } from '@angular/router';
import { SimpleTravelService } from './simple-travel.service';
import { Observable } from 'rxjs/Observable';
import { StaticService } from '../core/static.service';
import { BoardType, ProductType, Region } from '../core/core.types';

@Component({
  template: `
      <b4a-product-simple-travel-form
          [travel]="travel"
          [boardTypes]="boardTypes"
          [regions]="regions"
          [productTypes$]="productTypes$"
      ></b4a-product-simple-travel-form>
    `
})
export class SimpleTravelDetailPageComponent implements OnInit {

  travel: SimpleTravel;

  boardTypes: BoardType[];

  productTypes$: Observable<ProductType[]>

  regions: Region[];

  constructor(
    private route: ActivatedRoute,
    private travelService: SimpleTravelService,
    private staticService: StaticService,
    private router: Router
  ) {
        this.route.params
      .switchMap((params: Params) => {
        if (params.id === 'new') {
          return Observable.of(this.travelService.getSimpleTravelSkeleton());
        } else {
          // return this.travelService.getSimpleTravel(+params.id);
          return Observable.of(this.travelService.getSimpleTravelSkeleton());
        }
      })
      .subscribe((travel) => {
this.travel = travel
});
  }

  ngOnInit() {
      this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
     }
     this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
           // trick the Router into believing it's last link wasn't previously loaded
           this.router.navigated = false;
           // if you need to scroll back to top, here is the right place
           window.scrollTo(0, 0);
        }
    });



    this.productTypes$ = this.staticService.getProductTypes();

    this.staticService.getBoardTypes()
      .subscribe(data => this.boardTypes = data);

    // this.staticService.getRegions()
    //   .subscribe(data => this.regions = data);
  }
}



// WEBPACK FOOTER //
// ./src/app/product/simple-travel-detail-page.container.ts